import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  genericError: {
    id: 'masquerade-widget.userName.error.generic',
    defaultMessage: 'An error has occurred; please try again.',
    description: 'Message shown after a general error when attempting to masquerade',
  },
  placeholder: {
    id: 'masquerade-widget.userName.input.placeholder',
    defaultMessage: 'Username or email',
    description: 'Placeholder text to prompt for a user to masquerade as',
  },
  userNameLabel: {
    id: 'masquerade-widget.userName.input.label',
    defaultMessage: 'Masquerade as this user',
    description: 'Label for the masquerade user input',
  },
  viewCourseAs: {
    id: 'masquerade-widget.user.select.label',
    defaultMessage: 'View this course as:',
    description: 'Label for the masquerade user slection dropdown',
  },
  viewCourseIn: {
    id: 'masquerade-widget.user.select.label.platform',
    defaultMessage: 'View course in:',
    description: 'Label for the masquerade user slection dropdown',
  }
});

export default messages;
